import { service } from '@/ajax/request'

/**
 * 品牌方数据大屏设置
 * 一个品牌方对应一条配置，merchantId 即该配置的主键（关联 merchant.id）
 */
export interface BoardConfigParams {
  // 品牌方ID（主键，新增/编辑必填）
  merchantId: number | string
  // 链接开关：0-关，1-开
  linkSwitch: number
  // 链接刷新间隔(秒)，正整数且 >15
  refreshInterval?: number
  // 可展示终端数(正整数，限制同时打开大屏个数)
  terminalLimit?: number
  // 热点图logo图片url
  logo?: string
  aiEvalCoefficient?: number
  storeCountCoefficient?: number
  smartTerminalCoefficient?: number
  tcmBrainCoefficient?: number
  provinceCoefficient?: number
  cityCoefficient?: number
}

// 大屏设置详情（回填），id 传品牌方ID
export const getBoardConfigDetail = (id: number | string) => {
  return service({
    url: `/board/config/detail/${id}`,
    method: 'POST',
    type: 'form',
  })
}

// 新增/编辑大屏设置
export const saveOrUpdateBoardConfig = (params: BoardConfigParams) => {
  return service({
    url: `/board/config/save-update`,
    method: 'POST',
    params,
  })
}

// 获取大屏链接，id 传品牌方ID
// custom: 关闭拦截器的统一报错，调用方优先用后端返回的报错信息提示，无报错信息时才用兜底文案
export const getBoardConfigCopyUrl = (id: number | string) => {
  return service({
    url: `/board/config/copy-url/${id}`,
    method: 'POST',
    type: 'form',
    custom: true,
  })
}
